<template>
<div class="goods">
    <v-head :title="title"></v-head>
      <div class="btns">
            <span :class="{'active' : mode == const_invoice_status_already}" @click="changeListBtn(const_invoice_status_already)">已开票</span>
            <span :class="{'active' : mode == 0}" @click="changeListBtn(0)">待开票</span>
        </div>
        <div class="fontsBox">
            <invoiceWords></invoiceWords>
          </div>
    <div class="content">
        <div class="order-list">
            <div class="warmTips" v-if="orderList.content && !orderList.content.length">
              <img src="../../assets/images/404.png"/>
              <span>没有找到相应内容哦</span>
            </div>
            <template v-for="item in orderList.content">
                <invoice-order
                        :item="item"
                        :key="item.title"
                ></invoice-order>
            </template>
          </div>
    </div>
</div>
</template>

<script>
import { Field, Button,Toast,CellGroup } from "vant";
import invoiceOrder from "@/components/invoice"
import vHead from "../../components/Subhead.vue";
import {getOrderInfo} from "@/api/dictionary";
import invoiceWords from "wordsPath/invoiceWords.vue";
export default {
  data() {
    return {
        mode: 0,
        const_invoice_status_no:1,
        const_invoice_status_apply:2,
        const_invoice_status_already:3,
        const_order_status_paid:5,
        title:"发票列表",
        loading: true,
        page: 1,
        filterBox: {
            invoiceStatus: 0
        },
        orderList: {
            content: []
        },
        navActive:3,
    };
  },
  props: ["orderType"],
  filters: {
    
  },
  components: {
      vHead,
      invoiceOrder,
      invoiceWords
  },
  methods: {
     changeListBtn:function(value){
          //切换已开和未开列表
          this.mode=value;
          this.filterBox.invoiceStatus=value;
          this.getData();
      },
     changActive(val){
          this.navActive = val;
      },
      getData: function() {
          this.loading = true;
          this.page=1;

          var params=this.filterBox;
        //   if(this.type==1){
        //       params.orderTypeList = [1,3,4,5,6];
        //   }else {
        //       params.orderStatusList = this.const_order_status_paid;
        //   }
          params.orderType = this.type;
          params.access_token = sessionStorage.getItem("access_token");
          getOrderInfo(params, this.page - 1)
              .then(res => {
                  if (res.success) {
                      this.orderList = res.result;
                  }else{
                      Toast.fail(res.message);
                  }
              })
              .catch(() => {
                  Toast.fail("获取数据失败");
              })
              .finally(() => {
                  this.loading = false;
              });
      },
  },
  computed: {
    type(){
        return this.$route.query&&this.$route.query.type;
    }
  },
  watch:{
	
  },
  mounted() {
	  this.getData();
  }

}
</script>
<style  lang="less" scoped>
    .Payment{
        position: absolute;
        z-index: 9999;
        right: 20px;
        top: 21px;
        color: #fff;
    }

    .Order{ background: #fafafa; padding:15px 0; margin-top: 15px; }
    .Order p{ line-height: 24px; color: #848484; }
    .fontsBox{
        width: 86%;
        margin:20px auto 0 auto;
        background: #fff6ec;
        padding:14px;
        font-size: 13px;
        border: #f6d0a2 dashed 1px;
        line-height: 22px;
        color: #ffbe4e;
    }
    .warmTips,.orderTip{     font-size: 16px;
        text-align: center;
        margin-top: 25%; }
.btns {
  display: flex;
  width: 354px;
  height: 46px;
  margin: 20px auto;
  border: 1px solid #228ccd;
  text-align: center;
  justify-content: space-between;
  user-select: none;
  span {
    display: flex;
    width: 50%;
    height: 100%;
    font-size: 14px;
    color: #228ccd;
    cursor: pointer;
    justify-content: center;
    align-items: center;
  }
  .active {
    color: #fff;
    background: #228ccd;
  }
}
</style>